import React from 'react';
import { portfolioData } from '../data/mock';

const Footer = () => {
  const { contact } = portfolioData;

  return (
    <footer data-testid="footer-section" className="relative py-24 md:py-32 bg-[#0A0A0A] border-t border-white/5 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-8">
          <div>
            <p className="font-serif text-2xl md:text-3xl font-light text-white tracking-tight mb-4">
              Nitin Sharma
            </p>
            <p className="text-sm font-light text-white/40">
              Photography & Cinematography
            </p>
          </div>
          <div className="flex flex-col md:items-end gap-3">
            <div className="flex gap-6">
              {Object.entries(contact.social).map(([name, url]) => (
                <a
                  key={name}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${name}`}
                  className="text-xs uppercase tracking-[0.2em] text-white/30 hover:text-white transition-colors duration-300 link-underline"
                >
                  {name}
                </a>
              ))}
            </div>
            <p className="text-xs text-white/20 mt-2" data-testid="footer-copyright">
              &copy; {new Date().getFullYear()} Nitin Sharma Photography. All rights reserved.
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 pointer-events-none select-none overflow-hidden" aria-hidden="true">
        <p className="font-serif text-[12vw] leading-none text-white/[0.02] whitespace-nowrap text-center tracking-tighter">
          NITIN SHARMA
        </p>
      </div>
    </footer>
  );
};

export default Footer;
